import * as React from 'react';
import * as classNames from 'classnames';

class Spinner extends React.Component {
  classNames = () => classNames('loading-component', this.props.size);

  getWings = () => {
    const wings = [];
    const wingCount = this.props.size == 'small' ? 3 : 5;
    const color = (this.props.color) ? { backgroundColor: this.props.color } : null;

    for (let i = 0; i < wingCount; i++) {
      const wing = {
        classNames: `rect rect${i + 1}`,
        style: color,
      };

      wings.push(wing);
    }

    return wings;
  };

  render() {
    return (
      <div className={this.classNames()}>
        {this.getWings().map((wing, index) => <div key={index} className={wing.classNames} style={wing.style} />)}
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./javascripts/components/shared/spinner.jsx